<template>
  <div class="footer">
    <div class="footer__container container">
      <div class="footer__items">
        <div class="footer__item">
          <div class="footer__social">
            <a
              v-for="item in socials"
              :key="item.icon"
              class="footer__social-item"
              :href="item.link"
              target="_blank"
            >
              <Icon :name="item.icon"></Icon>
            </a>
          </div>
        </div>
        <div class="footer__item footer__copyright">
          {{ copyright }}
          <template
            v-for="(link, i) in links"
          >
            &nbsp;|&nbsp;
            <RrLink
              :key="i"
              class="color-white"
              :text="link.text"
              :href="link.link"
              target="_blank"
              variant="inherit"
              size="sm"
            ></RrLink>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@rr-component-library/icon/src/main';

export default {
  name: 'Footer',
  components: {
    Icon,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      data: {
        copyright: '© Интернет - магазин TopLiga в Краснодаре',
        links: [
          {
            text: 'Публичная оферта',
            link: 'https://topliga.ru/company/oferta/',
          },
        ],
        socials: [
          {
            icon: 'vkontakte',
            link: 'https://vk.com/topligarun',
          },
          {
            icon: 'telegram',
            link: 'https://t.me/topligarun',
          },
          {
            icon: 'youtube',
            link: 'https://www.youtube.com/channel/UCs3bxjNOOq0w9LgwgDChUiw',
          },
        ],
      },
    };
  },
  computed: {
    copyright() {
      return this.data.copyright || '';
    },
    socials() {
      return this.data.socials || [];
    },
    links() {
      return this.data.links || [];
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./Footer";
</style>
